// Alert.js
import React, { useEffect } from 'react';
import './Alert.css';

const Alert = ({ message, duration, onClose }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className="alert">
      {message}
    </div>
  );
};

export default Alert;
